import { render, staticRenderFns } from "./EncontrarOrcamento.vue?vue&type=template&id=135aefb5&scoped=true&"
import script from "./EncontrarOrcamento.vue?vue&type=script&lang=js&"
export * from "./EncontrarOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./EncontrarOrcamento.vue?vue&type=style&index=0&id=135aefb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135aefb5",
  null
  
)

export default component.exports